module.exports = __webpack_public_path__ + "OpenSans-Regular-55835483c304eaa8477fea2c36abba17.woff2";